import { SchemaField, FormData, FormErrors } from './types';

export const getDisplayValue = (
  field: SchemaField,
  formData: FormData
): string => {
  if (field.readonly && field.displayValue) {
    return field.displayValue;
  }
  return formData[field.name] as string;
};

// Clean, minimal input styling
export const getInputClass = (
  fieldName: string,
  errors: FormErrors,
  baseClass = ''
): string => {
  const hasError = errors[fieldName];
  const baseStyles =
    'w-full px-4 py-3 rounded-lg transition-all duration-200 text-gray-900 font-baijamjuree placeholder-gray-500 bg-white';

  if (hasError) {
    return `${baseStyles} border-2 border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-500/20 ${baseClass}`;
  } else {
    return `${baseStyles} border border-gray-300 focus:border-gray-500 focus:ring-2 focus:ring-gray-200 hover:border-gray-400 ${baseClass}`;
  }
};
